import BigNumber from 'bignumber.js';

import { Comptroller, DlVault } from 'types/contracts';

export interface GetMintedUmiInput {
  comptrollerContract: DlVault;
  accountAddress: string;
}

export type GetMintedUmiOutput = {
  balance: string;
  arp: string;
  stake: string;
  endClaimedDates: string;
  mintedVaiWei: string;
  firstClaimedDates: string;
  Rewards: string;
  syndicate: string;
  ClaimedDates: string;
  totalStaticReward: string;
  claimedStaticReward: string;
};

const getMintedUmi = async ({
  comptrollerContract,
  accountAddress,
}: GetMintedUmiInput): Promise<GetMintedUmiOutput> => {
  const res = await comptrollerContract.methods.getUserInfo(accountAddress).call();

  return {
    balance: res[0] || res.balance || '0',
    stake: res[1] || res.stake || '0',
    arp: res[2] || res.dailyReward || '0',
    Rewards: res[3] || res.totalRewards || '0',
    firstClaimedDates: res[4] || res.startTime || '0',
    endClaimedDates: res[5] || res.endTime || '0',
    ClaimedDates: res[6] || res.lastClaimTime || '0',
    syndicate: res[7] || res.directReferrals || '0',
    totalStaticReward: res[8] || res.totalStaticReward || '0',
    claimedStaticReward: res[9] || res.claimedStaticReward || '0',
    mintedVaiWei: res[3] || res.totalRewards || '0', // 使用 totalRewards
  };
};

export default getMintedUmi;
